import React, { useContext } from 'react';
import { useFetch } from 'hooks/use-fetch';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Modal from 'components/modal';
import PriceAlertInterface from '../../../../../modules/price-alert/price-alert.interface';
import { useModal } from 'hooks/use-modal';

const PriceAlertModal = React.lazy(() => import('./components/price-alert-modal'));
const PriceAlertModalConfirm = React.lazy(() => import('./components/price-alert-modal-confirm'));

interface ProductActionPriceAlertProps {
    price: number;
    productId: number;
}

const ProductActionPriceAlert: React.FC<ProductActionPriceAlertProps> = ({ price, productId }) => {
    const api = useContext(TeApiContext);
    const { post } = useFetch('/alert-cenowy/create');
    const confirmAlert = useModal('ALERT_CONFIRM');
    const priceAlert = useModal('ALERT_PRICE');

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isDesktop = api.getDevice() === 'desktop';

    const onSubmit = (formData: PriceAlertInterface): void => {
        post({ ...formData, productId }).then(confirmAlert.open);
    };

    return (
        <>
            <button
                aria-label="Alert cenowy"
                onClick={priceAlert.open}
                type="button"
                className={`btn btn--fw-600 btn-action ${api.getDevice()} gtm_ua_alert`}
            >
                <i className="icon icon-bell"/>
                {isDesktop ? 'Alert cenowy' : ''}
            </button>
            {
                priceAlert.isOpen && (
                    <Modal
                        showCloseIcon={false}
                        center={true}
                        isOpen={true}
                        onClose={priceAlert.close}
                        shouldCloseOnOverlayClick={isDesktop}
                        modalClassName="price-alert-modal"
                    >
                        <PriceAlertModal
                            productPrice={price}
                            formText="Powiadomimy Cię, gdy produkt osiągnie Twoją oczekiwaną cenę."
                            onSubmit={onSubmit}
                            closePriceAlertModal={priceAlert.close}
                        />
                    </Modal>
                )
            }
            {
                confirmAlert.isOpen && (
                    <Modal
                        showCloseIcon={false}
                        center={true}
                        isOpen={true}
                        onClose={confirmAlert.close}
                        shouldCloseOnOverlayClick={true}
                        modalClassName="price-alert-modal-confirm"
                    >
                        <PriceAlertModalConfirm onClose={confirmAlert.close}/>
                    </Modal>
                )
            }
        </>
    );
};

export default ProductActionPriceAlert;
